import { render, staticRenderFns } from "./ProcedureDirectoryWidget.vue?vue&type=template&id=6b474964&"
import script from "./ProcedureDirectoryWidget.vue?vue&type=script&lang=js&"
export * from "./ProcedureDirectoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProcedureDirectoryWidget.vue"
export default component.exports